import { gql } from '@apollo/client';
import { SELECT_OPTION_FIELDS } from 'graphql/types/SelectOptionType';

/**
 * 实现按业务场景返回客户下拉选项
 * - 入参：businessScenarioCode（Long）
 * - 返回：SelectOptionType[]（value=clientId, label=clientName/展示名）
 */
export const GET_PRICING_FAILURE_CLIENTS_BY_SCENARIO = gql`
    query GetPricingFailureClientsByScenario($businessScenarioCode: Long!) {
        getPricingFailureClientsByScenario(businessScenarioCode: $businessScenarioCode) {
            ...SelectOptionFields
        }
    }
    ${SELECT_OPTION_FIELDS}
`;

export interface GetPricingFailureClientsByScenarioResponse {
    getPricingFailureClientsByScenario: Array<{ value: string; label: string }>;
}

